var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mx-auto subMenuCard text-center",attrs:{"block":"","width":"100%","outlined":""},on:{"click":_vm.push}},[_c('v-icon',{staticClass:"my-lg-6 my-md-5 my-sm-5"},[_vm._v(_vm._s(_vm.svgPathComputed))]),_c('h5',{staticClass:"my-lg-6 my-md-5 my-sm-5"},[_vm._v(_vm._s(_vm.submenuComputed))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }